import {Component, EventEmitter, Input, Output} from '@angular/core';

import {MatButton, MatButtonModule} from "@angular/material/button";

@Component({
    selector: 'wire-button',
    templateUrl: './wire-button.component.html',
    imports: [
        MatButton
    ],
    styleUrls: ['./wire-button.component.less']
})
export class WireButtonComponent {
  @Input() btnContent: string = '';
  @Input() btnStyle: string = '';
  @Input() disabled: boolean = false;

  @Output() buttonClicked: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  onButtonClicked() {
    this.buttonClicked.emit(true);
  }
}
